import { render, staticRenderFns } from "./PerformanceTargetEditor.vue?vue&type=template&id=e4a00d00"
import script from "./PerformanceTargetEditor.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports